import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SearchComponent } from '../../search/search.component';

@Component({
  standalone: true,
  selector: 'app-search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss'],
  imports: [SearchComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchPanelComponent {}
